export const STORAGE_SESSION_KEY = 'mostra_group_session';
